import { Component, Injector, inject, input, output } from '@angular/core';
import { SessionService } from "../../services/session.service";
import { authorizedMarshal } from '../../auth/auth.guard';

@Component({
    selector: 'edit-dialog',
    templateUrl: './edit-dialog.component.html',
    standalone: false
})
export class EditDialogComponent {
  injector = inject(Injector);
  session = inject(SessionService);

  readonly title = input<string>(undefined);
  readonly action = output<string>();

  okButtonLabel = input<string>('Save');

  authorizedMarshal: boolean = authorizedMarshal() || false;
}
